module.exports = __webpack_public_path__ + "fonts/latothinitalic.4ac7208b.ttf";